import service from "@/request/index";
const baseUrl = window.globalUrl.HOME_API;

/**
 * 银行人员和银行主管查看任务列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} [params.companyName] - 贷款人
 * @returns {Promise}
 */
export function getTaskList(params) {
  return service({
    url: `${baseUrl}/trade-website/apply/selectTaskList`,
    method: 'get',
    params
  })
}

/**
 * 银行人员和银行主管审批
 * @param {Object} params - 参数
 * @param {number} params.isAgree - 是否同意 0同意 1不同意
 * @param {number} params.opinion - 审批意见
 * @param {number} params.taskId - 	任务id
 * @returns {Promise}
 */
export function approvalRepayment(params) {
  return service({
    url: `${baseUrl}/trade-website/apply/approvalRepayment`,
    method: 'post',
    data: params
  })
}
